import { SlideFade, Spacer, Text, Container, Flex, HStack } from '@chakra-ui/react'
import { cartAddItem } from '../states/cartActions'
import { IconAddToCart, BadgeQty, BadgeSoldOut, Card, BadgeInCart } from '../common'
import ChkoutLinkButton from './ChkoutLinkButton'

// availability is now toggled from the kitchen app (ecomserving), not here
// — both builds just read it and disable the same way, kiosk included
const Product = ({ selected, qty, product }) => {
  const available = product.available !== false

  const addItemHandle = selected => () => {
    if (!available) return
    if (!selected) {
      cartAddItem(product)
    }
  }

  return (
    <Card selected={selected} disabled={!available} onClick={addItemHandle(selected)}>
      <Flex w='100%' alignItems='center'>
        <Container px='0'><Text textStyle='itemTitle' w='auto' isTruncated>{product.name}</Text></Container>
      </Flex>
      <Flex w='100%' alignItems='center'>
        <Text mr='1' textStyle='prodPrice'>${product.price}</Text>
        <Spacer />
        {!available ?
          <BadgeSoldOut>Sold out</BadgeSoldOut>
          : selected ?
          <SlideFade in={selected} offsetY='20px'>
            <HStack>
              <BadgeQty>{qty}</BadgeQty>
              <BadgeInCart> in cart</BadgeInCart>
              <ChkoutLinkButton />
            </HStack>
          </SlideFade>
          :
          <IconAddToCart />}
      </Flex>
    </Card>
  )
}

export default Product